// extracted by mini-css-extract-plugin
export default {"chevron":"CollapseChevron_chevron__zM4ZW","expanded":"CollapseChevron_expanded__55Ait"};